module.exports = __webpack_public_path__ + "static/media/6.cfd9319a.jpg";